(function () {
  if (window.__registaSizeFinderLoaded) return;
  window.__registaSizeFinderLoaded = true;

  var mapPromise = null;
  var productCache = new Map();

  function getMap(url) {
    if (!mapPromise) {
      mapPromise = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Size map could not be loaded');
        return response.json();
      });
    }
    return mapPromise;
  }

  function baseHandleFrom(handle) {
    return String(handle || '').replace(/-size-[a-z0-9-]+$/i, '');
  }

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + handle;
  }

  function productJsonUrl(handle) {
    return productUrl(handle) + '.js';
  }

  function fetchAvailability(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    var promise = fetch(productJsonUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return { exists: false, available: false };
      return response.json().then(function (product) {
        var available = typeof product.available === 'boolean'
          ? product.available
          : Array.isArray(product.variants) && product.variants.some(function (variant) { return variant.available; });
        return { exists: true, available: !!available };
      });
    }).catch(function () {
      return { exists: false, available: false };
    });

    productCache.set(handle, promise);
    return promise;
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = hidden;
  }

  function makeRow(size, handle, state, currentHandle) {
    var isCurrent = handle === currentHandle;
    var available = state && state.exists && state.available;
    var row = document.createElement(available && !isCurrent ? 'a' : 'div');

    row.className = 'regista-size-finder__size';
    if (isCurrent) row.classList.add('regista-size-finder__size--current');
    else if (available) row.classList.add('regista-size-finder__size--available');
    else row.classList.add('regista-size-finder__size--sold-out');

    if (available && !isCurrent) {
      row.href = productUrl(handle);
      row.setAttribute('aria-label', 'Open size ' + size);
    }

    var sizeLabel = document.createElement('span');
    sizeLabel.className = 'regista-size-finder__size-label';
    sizeLabel.textContent = size;

    var status = document.createElement('span');
    status.className = 'regista-size-finder__status';

    if (isCurrent) {
      status.classList.add('regista-size-finder__status--current');
      status.textContent = 'CURRENT SIZE';
    } else if (available) {
      status.classList.add('regista-size-finder__status--available');
      status.textContent = 'IN STOCK';
    } else {
      status.classList.add('regista-size-finder__status--sold-out');
      status.textContent = 'OUT OF STOCK';
    }

    var arrow = document.createElement('span');
    arrow.className = 'regista-size-finder__chevron';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = available && !isCurrent ? '→' : '';

    row.appendChild(sizeLabel);
    row.appendChild(status);
    row.appendChild(arrow);
    return row;
  }

  function renderSizes(widget, items) {
    var currentHandle = widget.getAttribute('data-current-handle') || '';
    var list = widget.querySelector('[data-regista-size-finder-sizes]');
    var loading = widget.querySelector('[data-regista-size-finder-loading]');
    var empty = widget.querySelector('[data-regista-size-finder-empty]');

    return Promise.all(items.map(function (item) {
      return fetchAvailability(item[1]).then(function (state) {
        return { size: item[0], handle: item[1], state: state };
      });
    })).then(function (results) {
      if (!list) return;
      list.innerHTML = '';

      var valid = results.filter(function (result) { return result.state.exists; });
      valid.forEach(function (result) {
        list.appendChild(makeRow(result.size, result.handle, result.state, currentHandle));
      });

      setHidden(loading, true);
      setHidden(list, valid.length === 0);
      setHidden(empty, valid.length !== 0);
    });
  }

  function closeWidget(widget) {
    var overlay = widget.querySelector('[data-regista-size-finder-overlay]');
    var trigger = widget.querySelector('[data-regista-size-finder-open]');
    if (!overlay) return;
    overlay.hidden = true;
    document.body.classList.remove('regista-size-finder-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }
  }

  function openWidget(widget) {
    var overlay = widget.querySelector('[data-regista-size-finder-overlay]');
    var modal = widget.querySelector('[data-regista-size-finder-modal]');
    var trigger = widget.querySelector('[data-regista-size-finder-open]');
    var list = widget.querySelector('[data-regista-size-finder-sizes]');
    var loading = widget.querySelector('[data-regista-size-finder-loading]');
    var empty = widget.querySelector('[data-regista-size-finder-empty]');
    var mapUrl = widget.getAttribute('data-map-url');
    var currentHandle = widget.getAttribute('data-current-handle') || '';
    var baseHandle = baseHandleFrom(currentHandle);

    if (!overlay || !mapUrl || !baseHandle) return;

    overlay.hidden = false;
    document.body.classList.add('regista-size-finder-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (modal) window.setTimeout(function () { modal.focus({ preventScroll: true }); }, 0);

    setHidden(loading, false);
    setHidden(list, true);
    setHidden(empty, true);

    getMap(mapUrl).then(function (map) {
      var items = map[baseHandle] || [];
      if (!items.length) {
        setHidden(loading, true);
        setHidden(empty, false);
        return;
      }
      return renderSizes(widget, items);
    }).catch(function () {
      setHidden(loading, true);
      if (empty) {
        empty.textContent = 'We could not check the other sizes right now. Please try again.';
        setHidden(empty, false);
      }
    });
  }

  function bindWidget(widget) {
    if (!widget || widget.dataset.registaSizeFinderBound === 'true') return;
    widget.dataset.registaSizeFinderBound = 'true';

    var trigger = widget.querySelector('[data-regista-size-finder-open]');
    if (trigger) trigger.addEventListener('click', function () { openWidget(widget); });

    widget.querySelectorAll('[data-regista-size-finder-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeWidget(widget); });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-regista-size-finder]').forEach(bindWidget);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openOverlay = document.querySelector('[data-regista-size-finder-overlay]:not([hidden])');
    if (!openOverlay) return;
    var widget = openOverlay.closest('[data-regista-size-finder]');
    if (widget) closeWidget(widget);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
